import React from "react";
import publicIp from "react-public-ip";
import authenticationService from "./services/authenticationService";
import AppContext from "./context/Context";
import { reloadPage } from "./helpers/utils";

let ipAddress = "";

async function getIPAddress() {
  ipAddress = await publicIp.v4();
}
getIPAddress();

const getSudDetails = sessionStorage.getItem("s_u_d")
  ? JSON.parse(sessionStorage.getItem("s_u_d"))
  : {};

window.onload = () => {
  let fullbodyElement = document.querySelector(".fullbody");

  if (fullbodyElement) {
    fullbodyElement.remove();
  }
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static contextType = AppContext;

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, errorCount: 0 };
  }

  componentDidCatch(error, errorInfo) {
    const { loginUserDetails } = this.context;
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);

    // console.log("error",error,"errorInfo",errorInfo?.componentStack);

    const iframes = document.getElementsByTagName("iframe");
    if (iframes.length > 0) {
      // Remove the last iframe
      setTimeout(() => {
        const lastIframe = iframes[iframes.length - 1];
        lastIframe.parentNode.removeChild(lastIframe);
      }, 5000);
    }

    const body = {
      dev_name: loginUserDetails?.dev_name || "Not Applicable",
      user_name: loginUserDetails?.user_name || "Not Applicable",
      partner_name: loginUserDetails?.partner_name || "Not Applicable",
      host_url: window?.location?.href,
      ip_address: ipAddress,
      error_msg: `${error}`,
      file_name: errorInfo?.componentStack,
    };
    if (!window.location.href.includes("localhost")) {
      authenticationService.PostErrorBoundaries(body);
    }

    setTimeout(() => {
      const reloadCount = localStorage.getItem("retry_loading")
        ? Number(JSON.parse(localStorage.getItem("retry_loading")))
        : 0;
      const isErrorRefreshButton = localStorage.getItem("error_refresh_button")
        ? Boolean(JSON.parse(localStorage.getItem("error_refresh_button")))
        : false;

      if (reloadCount <= 2 && !isErrorRefreshButton) {
        localStorage.setItem("retry_loading", reloadCount + 1);
        reloadPage();
      }else{
        localStorage.removeItem("retry_loading");
        localStorage.removeItem("error_refresh_button");
      }
      
    }, 1000);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
